<nz-card>
	<app-splitbutton *ngIf="!privacyMode && hasUserCreatePermission"
					[elements]="[userAddSplitButton]" class="tablebutton"
	></app-splitbutton>
	<nz-table #dynamicTable [nzData]="listOfDisplayData" [nzBordered]="bordered"
				[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
				[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzPageSize]="25" [nzFooter]="footer ? 'Here is the Footer' : null"
				[nzTitle]="title ? 'Here is the Title' : null" [nzSize]="size" (nzCurrentPageDataChange)="currentPageDataChange($event)"
				class="kit__utils__table"
				style="overflow-x: hidden"
	>
		<thead>
		<tr *ngIf="header">
			<th nzCustomFilter
				[nzSortFn]="compareUserName"
			>
				{{ 'user.username' | translate}}
				<nz-filter-trigger [(nzVisible)]="userNameFilterVisible" [nzActive]="userNameFilterValue.length > 0" [nzDropdownMenu]="menuUserName">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuUserName="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="userNameFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'user.username' | translate } }}" (ngModelChange)="filterUserName()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>
			<th nzCustomFilter
				[nzSortFn]="compareName"
			>
				{{ 'user.name' | translate}}
				<nz-filter-trigger [(nzVisible)]="nameFilterVisible" [nzActive]="nameFilterValue.length > 0" [nzDropdownMenu]="menuName">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuName="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="nameFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'user.name' | translate } }}" (ngModelChange)="filterName()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>
			<th nzCustomFilter
				[nzSortFn]="compareEmail"
			>
				{{ 'user.email_long' | translate}}
				<nz-filter-trigger [(nzVisible)]="emailFilterVisible" [nzActive]="emailFilterValue.length > 0" [nzDropdownMenu]="menuEmail">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuEmail="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="emailFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'user.email_long' | translate } }}" (ngModelChange)="filterEmail()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>
			<th nzCustomFilter
				[nzSortFn]="compareRoles"
			>
				{{ 'user.roles' | translate}}
				<nz-filter-trigger [(nzVisible)]="rolesFilterVisible" [nzDropdownMenu]="menuRoles">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuRoles="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<nz-checkbox-group [(ngModel)]="roles" (ngModelChange)="filterRoles()"></nz-checkbox-group>
					</div>
				</nz-dropdown-menu>
			</th>
		</tr>
		</thead>
		<tbody>
		<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
			<tr (click)="showUserEdit(data)">
				<td>{{ data.data.username }}</td>
				<td>{{ data.data.name }}</td>
				<td>{{ data.data.email }}</td>
				<td>{{ data.data.roles }}</td>
			</tr>
		</ng-template>
		</tbody>
	</nz-table>
</nz-card>
